/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//German (Germany)
export default {
  'project-actions.project-content.archive-error-title': 'Projekt konnte nicht wiederhergestellt werden',
  'project-actions.project-content.archive-project': 'Projekt archivieren',
  'project-actions.project-content.archive-restore-error-description':
    'Die Projektänderungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
  'project-actions.project-content.copy-link': 'Link kopieren',
  'project-actions.project-content.copy-project': 'Projekt kopieren',
  'project-actions.project-content.copy-project.cancel': 'Abbrechen',
  'project-actions.project-content.copy-project.close-modal': 'Fenster schließen',
  'project-actions.project-content.copy-project.error':
    'Geben Sie Ihrem Projekt einen Namen, damit jeder weiß, worum es geht.',
  'project-actions.project-content.copy-project.failed-description':
    'Beim Klonen des Projekts ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
  'project-actions.project-content.copy-project.failed-description-forbidden':
    'Sie sind nicht berechtigt, dieses Projekt zu kopieren.',
  'project-actions.project-content.copy-project.failed-title': 'Dieses Projekt konnte nicht geklont werden',
  'project-actions.project-content.copy-project.followers': 'Follower',
  'project-actions.project-content.copy-project.include': 'Einbeziehen',
  'project-actions.project-content.copy-project.links': 'Links',
  'project-actions.project-content.copy-project.project-name': 'Projektname',
  'project-actions.project-content.copy-project.submit': 'Senden',
  'project-actions.project-content.copy-project.success-description': 'Das Projekt wurde erfolgreich geklont.',
  'project-actions.project-content.copy-project.success-link': 'Zeigen Sie das geklonte Projekt an.',
  'project-actions.project-content.copy-project.success-title': 'Projekt "{projectName}" geklont.',
  'project-actions.project-content.copy-project.title': 'Projekt kopieren',
  'project-actions.project-content.follow': 'Folgen',
  'project-actions.project-content.follow-confirmation-description':
    'Wir senden Ihnen jeden Montagmorgen eine Zusammenfassung mit den Updates zu allen Projekten, denen Sie folgen. Warum montags? <a>Mehr erfahren</a>',
  'project-actions.project-content.follow-confirmation-title': '🙌🏼 Sie folgen jetzt diesem Projekt!',
  'project-actions.project-content.follow-error-title': 'Dem Projekt konnte nicht gefolgt werden',
  'project-actions.project-content.follow-unfollow-error-description':
    'Die Projektänderungen konnten nicht gespeichert werden. Bitte versuchen Sie es später erneut.',
  'project-actions.project-content.restore-project': 'Projekt wiederherstellen',
  'project-actions.project-content.share': 'Teilen',
  'project-actions.project-content.unfollow': 'Nicht mehr folgen',
  'project-actions.project-content.unfollow-error-title': 'Dem Projekt konnte nicht entfolgt werden',
};
